import StaffLayout from "@/components/StaffLayout";
import ReportForm from "@/components/ReportForm";

export default function StaffReportPage() {
  return (
    <StaffLayout>
      <div className="max-w-2xl mx-auto">
        <ReportForm variant="staff" />
      </div>
    </StaffLayout>
  );
}
